export default function Configure($stateProvider) {
	$stateProvider.state('stocks-gestion-rapport-activite-synthese', {
		parent: 'gestion',
		url: '/stocks-gestion-rapport-activite-synthese',
		views: {
			gestion: {
				template: '<ui-view></ui-view>'
			}
		},
		ncyBreadcrumb: {
			label: '{{ "LAYOUT.NAVIGATION.STOCKS" | translate }}'
		}
	});

	$stateProvider.state('stocks-gestion-rapport-activite-synthese.list', {
		url: '/list',
		template: '<stocks-gestion-rapport-activite-synthese></stocks-gestion-rapport-activite-synthese>',
		rights: { domain: 'stockjournalier', right: 'read' },
		ncyBreadcrumb: {
			label: '{{ "STOCKS_GESTION_RAPPORT_ACTIVITE.BREADCRUMBS.STOCKS_GESTION_RAPPORT_ACTIVITE_SYNTHESE" | translate}}'
		},
		navigation: {
			menu: 'stocks_no_category',
			translate: 'STOCKS_GESTION_RAPPORT_ACTIVITE.BREADCRUMBS.STOCKS_GESTION_RAPPORT_ACTIVITE_SYNTHESE',
			order: 2
		},
		search: 'STOCKS_GESTION_RAPPORT_ACTIVITE.BREADCRUMBS.STOCKS_GESTION_RAPPORT_ACTIVITE_SYNTHESE'
	});
}

Configure.$inject = ['$stateProvider'];
